<div class="cart-side-panel">
  <div class="cart-side-panel__header">
    <span class="cart-side-panel__title">Cart</span>
    <button ftrIconButton icon="Close" (click)="closePanel.emit()">Close</button>
  </div>
  <hr class="cart-side-panel__separator" />
  <div class="cart-side-panel__groups">
    @if (courtSystemId() && cartGroupIsPopulated()) {
      @for (group of cartGroups(); track group.key) {
        <div class="cart-side-panel__group">
          <ftr-request-cart-group-metadata
            [courtSystemId]="courtSystemId()!"
            [group]="group"
            [courthouseFullWidth]="true"
          />
          <div class="cart-side-panel__items">
            @for (item of group.items; track item.id) {
              <ftr-cart-times-display [requestedTimes]="item.requestedTimes" [maxVisible]="1" />
            }
          </div>
        </div>
      }
    } @else {
      <div class="cart-side-panel__empty-state">
        <ftr-empty-state
          message="Browse content to start adding recordings to your cart."
          icon="Cart"
          displayTitle="No Items in Cart"
        />
      </div>
    }
  </div>
  @if (cartGroups().length > 0 && checkoutPath()) {
    <hr class="cart-side-panel__separator" />
    <div class="cart-side-panel__buttons">
      <a ftrButton color="secondary" [fullWidth]="true" [routerLink]="cartPath" (click)="closePanel.emit()">
        Go to cart
      </a>
      <a ftrButton color="primary" [fullWidth]="true" [routerLink]="checkoutPath()" (click)="closePanel.emit()">
        Request
      </a>
    </div>
  }
</div>
